import React, { useState, useContext } from 'react'
import { Router, Link, navigate } from "@reach/router";
import Swal from 'sweetalert2'
import moment from 'moment-timezone'; 
import queryString from 'query-string';
import { css } from "@emotion/core";
import { ClipLoader, HashLoader } from "react-spinners";
import validator from 'validator';
import axios from 'axios'
import {SvgBackComponent, SVGProgressBar1, SVGProgressBar2, SVGProgressBar3, SVGProgressBar4, SvgExitComponent} from './SVGComponents';
import {useSpring, animated} from 'react-spring'
import { v4 as uuidv4 } from 'uuid';
import { config } from './config.js';
import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';
import Fade from 'react-reveal/Fade';
import classNames from 'classnames';

if (config.enableLogRocket) {
  LogRocket.init('cct1cv/scheduler', {dom: {
      textSanitizer: true,
      inputSanitizer: true,
    },
  });
  setupLogRocketReact(LogRocket);
}

function App({children}) {
  return (<div>
    <Router>
      <Home path="/"></Home>
      <Scheduler path="/calendar/*"></Scheduler>
    </Router>
  </div>);
};

const Home = () => {
  window.location.href = '/calendar';
  return <div></div>
};

const supportedTzList = [
  "Pacific/Honolulu",
  "America/Anchorage",
  "America/Los_Angeles",
  "America/Denver",
  "America/Phoenix",
  "America/Chicago",
  "America/New_York",
];

function guessTz() {
  var guessed = moment.tz.guess();
  var idx = supportedTzList.indexOf(guessed);
  return ( idx > -1 ) ? guessed : "America/Chicago";
}

function sendCloseMessage(link) {
  if (link === "close") {
    console.log("Sending Close Post Message");
    window.top.postMessage("close", '*');
  } else {
    window.location.href = link;
  }
}

export const SchedulerContext = React.createContext();
class Scheduler extends React.Component {

  constructor(props) {
    super(props);
    var state = {
      src: "", guid: "",
      sessionID: uuidv4(),
      flowVersion: "v1",

      exitLink: "",
      clickedGetStarted: false,
      modalIframe: false,
      scrollToTop: false,
      selectedState: "",
    }

    console.log(queryString.parse(window.location.search));
    if (state.src === "") 
      this.saveQueryParam(state, "src", "src");
  
    if (state.src === "")
      this.saveQueryParam(state, "source", "src")

    this.saveQueryParam(state, "guid", "guid");
    this.saveQueryParam(state, "exitLink", "exitLink");
    this.saveBoolQueryParam(state, "modalIframe", "modalIframe");
    this.saveBoolQueryParam(state, "scrollToTop", "scrollToTop");

    this.state = state;
    console.log(this.state);
  }

  saveQueryParam = (state, name, slot) => {
    let qs = queryString.parse(window.location.search);
    if (qs[name] === undefined || qs[name] === null || qs[name] === '') {
        return;
    } else {
        state[slot] = qs[name];
    }
  }

  saveBoolQueryParam = (state, name) => {
    let qs = queryString.parse(window.location.search);
    if (qs[name] === undefined || qs[name] === null || qs[name] === '') {
        return;
    } else {
        state[name] = true;
    }
  }

  render() { 
    return (
      <div>
        <SchedulerContext.Provider value={{
          schedulerState: this.state,
          setSelectedState: (selectedState) => { this.setState({selectedState: selectedState})},
          setClickedGetStarted: () => { this.setState({clickedGetStarted: true}) }
        }}>
          <Router>
            <StateSelector path="/" />
            <DateSelector path="/dates" />
            <TimeSelector path="/dates/:date/times" />
            <EnterAppointmentInformation path="/dates/:date/times/:time/zone/:tz1/:tz2/confirm" />
            <AppointmentConfirmed path="/dates/:date/times/:time/zone/:tz1/:tz2/confirmed" />
            <EnterWaitlistStateInformation path="/waitlist" />
            <OutOfCountryInformation path="/not_in_us" />
            <WaitlistThankYou path="/waitlist/confirmed" />
          </Router>
        </SchedulerContext.Provider>
      </div>
    );
  };
};


function BackButton({needsBack}) {
  return (
    needsBack === false ? <div className="w-6 h-6"></div> :
    <div className="w-6 h-6" onClick={() => navigate(-1)}>
      <SvgBackComponent  />
    </div>
  )
}

function ExitButton() {
  const {schedulerState} = useContext(SchedulerContext);
  
  return (
    schedulerState.exitLink === "" ? <div className="w-6 h-6"></div> :
    <div className="w-6 h-6" onClick={() => sendCloseMessage(schedulerState.exitLink)}>
      <SvgExitComponent  />
    </div>
  )
}

function ExitBackButtonHeader({needsBack}) {
  const {schedulerState} = useContext(SchedulerContext);
  return (
    <div className="flex justify-between">
      <BackButton needsBack={needsBack} />
      <ExitButton exitLink={schedulerState.exitLink} />
    </div>
  )
}

function DoneButton() {
  const {schedulerState} = useContext(SchedulerContext);
  return (
  <div className="flex flex-end flex-row-reverse">
    {schedulerState.exitLink !== "" ? 
      <div className="container max-w-sm mx-auto">
          <div className="text-center px-8 mb-8">
                <button onClick={() => sendCloseMessage(schedulerState.exitLink)} className="bg-primary hover:bg-primary-hover text-white font-bold py-4 w-full rounded-lg">
                    Done
                </button>
          </div>
      </div>
    :
      <div className="mt-8"></div>
    }
  </div>
  )
}

const statesList = [
  "Alabama", "Alaska", "Arizona", "Arkansas", "California",
  "Colorado", "Connecticut", "Delaware", "District Of Columbia", "Florida",
  "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana",
  "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine",
  "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri",
  "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey",
  "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio",
  "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina",
  "South Dakota", "Tennessee", "Texas", "Utah", "Vermont",
  "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"
];

function debounce(fn, ms) {
  let timer
  return _ => {
    clearTimeout(timer)
    timer = setTimeout(_ => {
      timer = null
      fn.apply(this, arguments)
    }, ms)
  };
}

function StateSelector() {
  const [enabledStates, setEnabledStates] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [notInUS, setNotInUS] = useState(false)

  const {schedulerState, setSelectedState, setClickedGetStarted} = useContext(SchedulerContext);

  React.useEffect(() => {
      setIsLoading(true);
      axios.get(`${config.endpoint}/v1/api/premium_states`)
           .then(function(response) {
              console.log("Fetched States: ")
              console.log(response.data.eligible_states);
              setEnabledStates(response.data.eligible_states);
           })
           .catch(function (error) {
            // handle error
            console.log(error);
          })
          .then(function() {
            setIsLoading(false);
          })
  }, []);

  const clickedNext = () => {
    if (schedulerState.selectedState === '' && !notInUS) {
      Swal.fire({
        title: 'Oops...',
        text: 'Please select a state to proceed.',
        icon: 'error',
        confirmButtonColor: '#1f4b75',
      });  
    } else if (enabledStates === [] || isLoading) {
      setSelectedState("Not Fetched");
      navigate("/calendar/dates")
    } else if (enabledStates.includes(schedulerState.selectedState)) {
      navigate("/calendar/dates")
    } else if (schedulerState.selectedState !== "") {
      navigate("/calendar/waitlist")
    } else if (notInUS) {
      navigate("/calendar/not_in_us")
    } else {
      navigate("/calendar/dates")
    }
  }

  const [dimensions, setDimensions] = React.useState({ 
    height: window.innerHeight,
    width: window.innerWidth
  })

  React.useEffect(() => {
    const debouncedHandleResize = debounce(function handleResize() {
      console.log('resized to: ', window.innerWidth, 'x', window.innerHeight)
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth
      })
    });

    window.addEventListener('resize', debouncedHandleResize);
    return _ => { window.removeEventListener('resize', debouncedHandleResize) };
  });

  const isMobile = dimensions.width < 640;
  const showWelcomeScreen = isMobile && schedulerState.clickedGetStarted === false;
  const welcomeClassNames = classNames(
    "flex flex-col antialiased max-w-sm mx-auto body-flex",
    {"hidden": !showWelcomeScreen},
    "sm:hidden" 
  )

  const rightColumnClassNames = classNames(
    "flex-col antialiased",
    {"body-flex": isMobile},
    showWelcomeScreen ? "all:hidden" : "all:flex",
    "sm:flex"
  )  

  const springDisplayWelcome = useSpring({to: {opacity: showWelcomeScreen ? 1 : 0}, from: {opacity: 0}})
  const springDisplayStates = useSpring({to: {opacity: !showWelcomeScreen ? 1 : 0}, from: {opacity: 0}})
  const overlayIframes = classNames(
    "sm:flex-row sm:flex sm:container sm:max-w-3xl",
    {"sm:mt-10 sm:shadow-lg sm:rounded-lg sm:mx-auto sm:h-screen": !schedulerState.modalIframe},
    {"hidden": showWelcomeScreen}
  )

  const desktopHeight = {}
  if (schedulerState.modalIframe && !isMobile) {
    desktopHeight["minHeight"] = 682;
  } else if (!isMobile) {
    desktopHeight["height"] = 600;
  }

  const nextclassnames = classNames(
    "text-white font-bold py-4 w-full rounded-lg",
    {"bg-primary hover:bg-primary-hover": !isLoading},
    {"bg-gray-300" : isLoading},
    {"mt-12" : (schedulerState.modalIframe && !isMobile)}
  )

  return (
    <div>
      <animated.div style={springDisplayWelcome}>
        <div className={welcomeClassNames}>
          <div className="flex-grow overflow-hidden">
            <div className="mt-4 mb-2 mx-4">
              <ExitBackButtonHeader needsBack={false} />
            </div>
            <div className="mb-8 mx-10 max-w-sm">
              <img alt="The NOCD appointment scheduler" src="data:image/png;base64,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" />
            </div>
          </div>
          <div className="px-8 mb-8">
              <button onClick={() => {setClickedGetStarted()}} className="text-center w-full text-white font-bold py-4 rounded-lg bg-primary hover:bg-primary-active focus:bg-secondary">
              Get Started
              </button>
          </div>
        </div>
      </animated.div>

      <animated.div style={springDisplayStates}>
        <div className={overlayIframes} style={desktopHeight}>
          <div className="hidden sm:block sm:bg-primary sm:w-1/3 sm:rounded-l-lg">
            <div className="mt-16 mx-4 mb-16">
              <img src="/assets/desktop_left_sidebar.png" className="object-contain w-full mx-auto" alt="NOCD can help by learning about what you are facing and offering information on if NOCD therapy is right for you." />
            </div>
          </div>

          <div className="sm:w-2/3 sm:rounded-r-lg">

            <div className={rightColumnClassNames}>
              <div className="mt-4 mb-2 mx-4">
                  <ExitBackButtonHeader needsBack={false} />
              </div>
              <div className="flex-grow container max-w-sm mx-auto">
                <div className="us:mb-4 mb-8 mx-20 progress_bar">
                  <SVGProgressBar1  />
                </div>
                <div className="">
                    <h1 className="text-center font-bold us:text-base text-2xl">Select your state</h1>
                    <p className="text-center mt-4 mx-8 us:text-sm text-base">Because of regulations, we have to make sure we find the best therapists in your state of residence.</p>
                </div>
                <div className="us:mt-6 mt-10 mx-8">
                    <div className="inline-block relative w-full">
                        <div>
                            <select value={schedulerState.selectedState} onChange={(e) => setSelectedState(e.target.value) }
                                    className="block appearance-none w-full bg-white font-bold us:text-base text-lg border-4 border-gray-400 us:px-3 us:py-4 us:border-2 px-5 pl-6 py-5 pr-6 rounded-lg focus:outline-none focus:shadow-outline">
                                <option value="">State*</option>
                                <optgroup label="United States">
                                {statesList.map(function(object, i) {
                                    return <option key={`${object}`} value={`${object}`}>{object}</option>
                                })}
                                </optgroup>
                            </select>
                            <div className="pointer-events-none absolute inset-y-0 right-4 flex items-center px-2">
                                <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 10"><path d="M0 0L10.5 10L21 0H0Z"/></svg>
                            </div>
                        </div>
                    </div>
                    <div className="container us:mt-4 mt-6 ml-2" >
                      <div className="w-full">
                        <label className="block text-black">
                            <input type="checkbox" value={notInUS} onChange={(e) => setNotInUS(!notInUS) }
                                  className="form-checkbox h-6 w-6 text-primary border-primary border-4"  />
                            <span className="us:text-sm text-base ml-2 pt-4 cursor-pointer">I currently live outside the U.S.</span>
                        </label>                          
                      </div>
                    </div>
                </div>
              </div>
              <div className="container max-w-sm mx-auto mt-10 sm:mt-24">
                <div className="text-center px-8 mb-8">
                    <button disabled={isLoading} className={nextclassnames} onClick={clickedNext}>
                      {isLoading ? "Loading..." : "Next" }
                    </button>
                </div>
              </div>
            </div>
          
          </div>
        </div>
      </animated.div>
    </div>)
}

function formatDate(date) {
  var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

  if (month.length < 2) 
      month = '0' + month;
  if (day.length < 2) 
      day = '0' + day;

  return [year, month, day].join('-');
}

function DateSelector(props) {
  const [allDays, setAllDays] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  const today = new Date()
  const tomorrow = new Date(today)
  tomorrow.setDate(tomorrow.getDate() + 1)
  
  const todayFormat = formatDate(today)
  const tomorrowFormat = formatDate(tomorrow)

  const springDisplay = useSpring({opacity: 1, from: {opacity: 0}})
  const springListDisplay = useSpring({to: {opacity: isLoading ? 0 : 1}, from: {opacity: 0}})
  const {schedulerState} = useContext(SchedulerContext);


  React.useEffect(() => {
      axios.get(`${config.endpoint}/api/v1/15min-call/dates`)
      .then(function(response) {
          var data = response.data;
          console.log("Fetched Dates: ")
          console.log(data);
          var spliceIdx = 0;
          const updatedData = data.map(function(entry, idx) {
            
              if (entry["date"] === todayFormat) {
                entry["title"] = "Today";
                spliceIdx = idx;
              } else if (entry["date"] === tomorrowFormat) {
                entry["title"] = "Tomorrow";
              } else {
                entry["title"] = entry["day_of_week"];
              }

              return entry;
          });

          const splicedData = updatedData.splice(spliceIdx);

          setAllDays(splicedData.splice(0, 8));
          setIsLoading(false);
      })
      .catch(function (error) {
      // handle error
      console.log(error);
    })
    .then(function() {
      setIsLoading(false);
    })
  }, [todayFormat, tomorrowFormat]);


  const [dimensions, setDimensions] = React.useState({ 
    height: window.innerHeight,
    width: window.innerWidth
  })

  React.useEffect(() => {
    const debouncedHandleResize = debounce(function handleResize() {
      console.log('resized to: ', window.innerWidth, 'x', window.innerHeight)
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth
      })
    });

    window.addEventListener('resize', debouncedHandleResize);
    return _ => { window.removeEventListener('resize', debouncedHandleResize) };
  });

  React.useEffect(() => {
    if (schedulerState.scrollToTop) {
      window.top.scrollTo(0, 0)
    }
  }, [allDays, schedulerState.scrollToTop])
  

  const isMobile = dimensions.width < 640;
  const rightColumnClassNames = classNames(
    "flex-col antialiased",
    {"body-flex": isMobile},
    "all:flex",
  )  

  const listHeight = {}
  const desktopHeight = {}
  if (schedulerState.modalIframe && !isMobile) {
    desktopHeight["minHeight"] = 682;
  } else if (!isMobile) {
    desktopHeight["height"] = 600;
    listHeight["height"] = 400;
    listHeight["overflowY"] = "auto";
  }

  const overlayIframes = classNames(
    "sm:flex-row sm:flex sm:container sm:max-w-3xl",
    {"sm:mt-10 sm:shadow-lg sm:rounded-lg sm:mx-auto sm:h-screen": !schedulerState.modalIframe},
  )


  return (<animated.div style={springDisplay}>
  <div className={overlayIframes} style={desktopHeight}>
    <div className="hidden sm:block sm:bg-primary sm:w-1/3 sm:rounded-l-lg">
      <div className="mt-16 mx-4 mb-16">
        <img src="/assets/desktop_left_sidebar.png" className="object-contain w-full mx-auto" alt="NOCD can help by learning about what you are facing and offering information on if NOCD therapy is right for you." />
      </div>
    </div>
    <div className="sm:w-2/3 sm:rounded-r-lg">
      <div className={rightColumnClassNames}>
        <div className="mt-4 mb-2 mx-4">
          <ExitBackButtonHeader needsBack={true} />
        </div>

        <div className="container max-w-sm mx-auto">
          <div className="text-center text-xs mb-3">
            Connect now? Call or text <span className="font-bold text-primary"><a href="tel:+13127666780">312-766-6780</a></span>
          </div>
          <div className="mb-6 mx-20 progress_bar">
            <SVGProgressBar2 />
          </div>
          <div>
            <h1 className="text-center font-bold us:text-base text-2xl">Choose a date</h1>
          </div>
          <div className="px-8 mt-5" style={listHeight}>
            <div className="mb-4 w-full mt-3">
                {isLoading ? 
                    <div className="mt-1/2">
                      <HashLoader
                        css={css`display: block; margin: 0 auto;`}
                        color="#00a3ad"
                        loading={isLoading} />
                    </div>
                :
                  <Fade up cascade>
                    <div className="no_webkit_link">
                  {allDays.map(function(object, i) {
                          return (
                            <div key={object["secondary_text"]}>
                            <animated.div style={springListDisplay}>
                              <div className="mx-4 mb-6">
                                <Link to={"/calendar/dates/" + object["date"] + "/times" }>
                                  <div className=" cursor-pointer border-primary border-4 py-3 rounded-lg w-full text-center hover:text-white hover:bg-primary hover:border-primary active:bg-primary-active active:border-primary-active">
                                    <div className="font-bold text-lg noselect">{object["title"]}</div>
                                    <div className="mt-1 noselect">{object["secondary_text"]}</div>
                                  </div>
                                </Link>
                              </div>
                            </animated.div>
                            </div>
                          );
                      })
                    }
                      </div>
                    </Fade>
                }
                
                <div className="w-full text-center mt-6 hidden">
                    <div className="underline cursor-pointer text-gray-900 hover:text-gray-700 active:text-gray-900">More days</div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </animated.div>)
}


function TimeSelector(props) {
  const [allTimes, setAllTimes] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [selectedTimezone, setSelectedTimezone] = useState(guessTz())
  const springDisplay = useSpring({opacity: 1, from: {opacity: 0}})
  const springListDisplay = useSpring({to: {opacity: isLoading ? 0 : 1}, from: {opacity: 0}})
  const {schedulerState} = useContext(SchedulerContext);

  React.useEffect(() => {
    axios.get(`${config.endpoint}/api/v1/15min-call/dates/` + props.date)
      .then(function(response) {
          var data = response.data;
          console.log("Fetched Times: ")
          console.log(data);
          setAllTimes(pickn(data, 10));
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
      .then(function() {
        setIsLoading(false);
      })
  }, [props.date]);


  const renderedDate = moment(props.date).format("dddd MMMM D, YYYY");

  const pickn = function(a, n) {
    try {
      if (a.length <= n) {
        return a;
      }
      
      var elems = [];
      var p = (a.length / n);
      for (var i = 0; i !== n; i++) {
        var val = a[Math.ceil(i * p)];
        if (val !== undefined) {
          elems.push(val)
        } else {
          console.log("Invalid Index");
          console.log(n, p, Math.ceil(i * p), a);
        }
      }
  
      return elems;
    } catch(err) {
      return a;
    }
  }
  
  const getTimeZoneList = () => {
    return allTimes.map(function(obj) {
      obj["pretty_time"] = moment(obj["time"]).tz(selectedTimezone).format("h:mm a")
      return obj;
    });
  }

  const [dimensions, setDimensions] = React.useState({ 
    height: window.innerHeight,
    width: window.innerWidth
  })

  React.useEffect(() => {
    const debouncedHandleResize = debounce(function handleResize() {
      console.log('resized to: ', window.innerWidth, 'x', window.innerHeight)
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth
      })
    });

    window.addEventListener('resize', debouncedHandleResize);
    return _ => { window.removeEventListener('resize', debouncedHandleResize) };
  });


  React.useEffect(() => {
    if (!schedulerState.scrollToTop) {
      window.top.scrollTo(0, 0)
    }
  }, [allTimes, schedulerState.scrollToTop])
  

  const isMobile = dimensions.width < 640;
  const rightColumnClassNames = classNames(
    "flex-col antialiased",
    {"body-flex": isMobile},
    "all:flex"
  )  

  const listHeight = {}
  const desktopHeight = {}
  if (schedulerState.modalIframe && !isMobile) {
    desktopHeight["minHeight"] = 682;
  } else if (!isMobile) {
    desktopHeight["height"] = 600;
    listHeight["height"] = 350;
    listHeight["overflowY"] = "auto";
  }
  
  const overlayIframes = classNames(
    "sm:flex-row sm:flex sm:container sm:max-w-3xl",
    {"sm:mt-10 sm:shadow-lg sm:rounded-lg sm:mx-auto sm:h-screen": !schedulerState.modalIframe},
  )


  return (<animated.div style={springDisplay}>
    <div className={overlayIframes} style={desktopHeight}>
      <div className="hidden sm:block sm:bg-primary sm:w-1/3 sm:rounded-l-lg">
        <div className="mt-16 mx-4 mb-16">
          <img src="/assets/desktop_left_sidebar.png" className="object-contain w-full mx-auto" alt="NOCD can help by learning about what you are facing and offering information on if NOCD therapy is right for you." />
        </div>
      </div>
      <div className="sm:w-2/3 sm:rounded-r-lg">
        <div className={rightColumnClassNames}>
          <div className="mt-4 mb-2 mx-4">
            <ExitBackButtonHeader needsBack={true} />
          </div>
  
          <div className="flex-grow container max-w-sm mx-auto">
            <div className="text-center text-xs mb-3">
              Connect now? Call or text <span className="font-bold text-primary"><a href="tel:+13127666780">312-766-6780</a></span>
            </div>
            <div className="mb-6 mx-20 progress_bar">
              <SVGProgressBar3 />
            </div>
            <div>
              <h1 className="text-center font-bold us:text-base text-2xl">Choose a time</h1>
              <div className="mx-auto mb-4 mt-2 text-center"> 
                  <p className="inline-block ml-2">{renderedDate}</p>
              </div>
            </div>

            <div className="inline-block relative w-full">
              <div className="mx-12">
                <select value={selectedTimezone} onChange={(e) => setSelectedTimezone(e.target.value)}
                    className="block appearance-none bg-white outline-none w-full text-center text-secondary pl-4 py-2 us:text-xs text-sm outline-none rounded-lg focus:outline-none focus:shadow-outline active:outline-none active:shadow-outline" name="timezone" id="timezone">
                  <optgroup label="United States">
                    <option value="Pacific/Honolulu">(GMT-10:00) Hawaii Time</option>
                    <option value="America/Anchorage">(GMT-9:00) Alaska Time</option>
                    <option value="America/Los_Angeles">(GMT-8:00) Pacific Time</option>
                    <option value="America/Denver">(GMT-7:00) Mountain Time</option>
                    <option value="America/Phoenix">(GMT-7:00) Arizona Time</option>
                    <option value="America/Chicago">(GMT-6:00) Central Time</option>
                    <option value="America/New_York">(GMT-5:00) Eastern Time</option>
                  </optgroup>
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-16 flex items-center px-2">
                  <svg className="fill-current h-3 w-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 11"><path d="M0 0L11.5 11L23 0H0Z" fill="#1F4B75"/></svg>
                </div>
              </div>
            </div>
            <div className="px-8" style={listHeight}>
              <div className="text-center pt-2 mt-3 sm:pt-3">
                {isLoading ? 
                      <div className="mt-1/3">
                        <HashLoader
                          css={css`display: block; margin: 0 auto;`}
                          color="#00a3ad"
                          loading={isLoading} />
                      </div>
                  :

                  <Fade up cascade>
                    <div className="no_webkit_link">
                    {getTimeZoneList().map(function(object, i) {
                        return (
                          <div key={object["time"]}>
                          <animated.div style={springListDisplay}>
                          <div className="mx-4">
                            <Link to={"/calendar/dates/" + props.date + "/times/" + object["time"] + "/zone/" + selectedTimezone + '/confirm' }>
                              <div className="cursor-pointer border-primary border-4 py-3 rounded-lg w-full mb-4 hover:text-white hover:bg-primary hover:border-primary active:bg-primary-active active:border-primary-active">
                                  <div className="mt-1 noselect">{object["pretty_time"]}</div>
                              </div>
                            </Link>
                          </div>
                          </animated.div>
                          </div>
                        );
                    })
                    }
                    </div>
                  </Fade>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </animated.div>)
}

function EnterAppointmentInformation(props) {
  const [isLoading, setIsLoading] = useState(false)
  const {schedulerState} = useContext(SchedulerContext);

  const [userData, setUserData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: ''
  })
  const [userValidation, setUserValidation] = useState({
      firstName: false,
      lastName: false,
      email: false,
      phone: false,
  })
  const [formValid, setFormValidation] = useState(false)
  const springDisplay = useSpring({opacity: 1, from: {opacity: 0}})


  // Tue June 10 2020 at 10:00am CST
  const timezone = props.tz1 + "/" + props.tz2;
  const rendered = moment(props.time).tz(props.tz1 + "/" + props.tz2).format("ddd MMM Do [at] h:mma z")

  const validateField = (fieldName, value) => {
    let { firstName, lastName, email, phone } = userValidation;
    switch (fieldName) {
        case 'email':
            var pattern = new RegExp(`(^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+[a-zA-Z0-9-.]+$)`);
            email = pattern.test(value);

            setUserValidation({
                ...userValidation, email
            })
            break;
        case 'firstName':
            pattern = new RegExp(`^[a-zA-Z]+([a-zA-Z]+)?$`);
            firstName = pattern.test(value);

            setUserValidation({
                ...userValidation, firstName
            })
            break;
        case 'lastName':
            pattern = new RegExp(`^[a-zA-Z]+([a-zA-Z]+)?$`);
            lastName = pattern.test(value);
            setUserValidation({
                ...userValidation, lastName
            })
            break;
        case 'phone':
            // var pattern = new RegExp('/^[(]?(\d{3})[)]?[-|\s]?(\d{3})[-|\s]?(\d{4})$/')
            const cleanedPhone = value.replace(/\D/g,'');
            phone = validator.isMobilePhone(cleanedPhone)
            setUserValidation({
                ...userValidation, phone
            })
            break;
        default:
            break;
    }
  }
  
  function handleChange(event) {
    var value = event.target.value;
    const newData = { ...userData, [event.target.name]: value };
    setUserData(newData);
    validateField(event.target.name, value);
    validateForm()
  }

  function onFocus(event) {
    validateField(event.target.name, event.target.value)
    validateForm()
  }

  const validateForm = () => {
    let valid = userValidation.firstName && userValidation.lastName && userValidation.email && userValidation.phone
    setFormValidation(valid)
  }


  const clickedNext = () => {
    validateForm()

    if (formValid) {
      const cleanedPhone = userData.phone.replace(/\D/g,'');
      if (!(cleanedPhone.length === 11 || cleanedPhone.length === 10)) {
        Swal.fire({
          title: 'Oops...',
          text: "Please ensure your phone number is a US number with 10 or 11 digits.",
          icon: 'error',
          confirmButtonColor: '#1f4b75',
        });  

        return;
      }

      setIsLoading(true)

      axios.post(`${config.endpoint}/api/v1/confirm_appointment`, {
        datetime: props.time,
        timezone: timezone,
        firstName: userData.firstName,
        lastName: userData.lastName,
        phone: cleanedPhone,
        email: userData.email,
        src: schedulerState.src,
        guid: schedulerState.guid,
        selectedState: schedulerState.selectedState
      })
      .then(function (response) {
        console.log("Response: ");
        console.log(response)
        navigate("/calendar/dates/" + props.date + "/times/" + props.time + "/zone/" + props.tz1 + "/" + props.tz2 + "/confirmed")
      })
      .catch(function (error) {
        console.log("Error: ");
        console.log(error.response);

        if (error.response.status === 400) {

          if (typeof(error.response.data) == "object") {
            if ("message" in error.response.data) {
              var message = error.response.data["message"] + " Please contact info@nocdhelp.com"

              if ("error" in error.response.data) {
                if (error.response.data["error"] === "no_available_calendar") {
                    message = "It seems that time is no longer available or has already been booked. Please select a different time or contact info@nocdhelp.com"
                }
              }

            } else {
              message = "An unexpected error occurred. Please contact info@nocdhelp.com";
            }

          } else if (typeof(error.response.data) == "string") {
            message = "An unexpected error occurred: " + error.response.data + ". Please contact info@nocdhelp.com";
          } else {
            message = "An unexpected error occurred. Please contact info@nocdhelp.com";
          }

        } else {
          message = "An unexpected error occurred. Please contact info@nocdhelp.com";
        }

        Swal.fire({
          title: 'Oops...',
          text: message,
          icon: 'error',
          confirmButtonColor: '#1f4b75',
        });  

      })
      .finally(function() {
        setIsLoading(false);
      })
          
    } else {
      Swal.fire({
        title: 'Oops...',
        text: 'Please enter the above fields to continue.',
        icon: 'error',
        confirmButtonColor: '#1f4b75'
      });  
    }
  }

  
  const [dimensions, setDimensions] = React.useState({ 
    height: window.innerHeight,
    width: window.innerWidth
  })

  React.useEffect(() => {
    const debouncedHandleResize = debounce(function handleResize() {
      console.log('resized to: ', window.innerWidth, 'x', window.innerHeight)
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth
      })
    });

    window.addEventListener('resize', debouncedHandleResize);
    return _ => { window.removeEventListener('resize', debouncedHandleResize) };
  });


  React.useEffect(() => {
    if (!schedulerState.scrollToTop) {
      window.top.scrollTo(0, 0)
    }
  }, [schedulerState.scrollToTop])
  
  const isMobile = dimensions.width < 640;
  const rightColumnClassNames = classNames(
    "flex-col antialiased",
    {"body-flex": isMobile},
    "all:flex"
  )  

  const desktopHeight = {}
  if (schedulerState.modalIframe && !isMobile) {
    desktopHeight["minHeight"] = 682;
  } else if (!isMobile) {
    desktopHeight["height"] = 600;
  }

  const overlayIframes = classNames(
    "sm:flex-row sm:flex sm:container sm:max-w-3xl",
    {"sm:mt-10 sm:shadow-lg sm:rounded-lg sm:mx-auto sm:h-screen": !schedulerState.modalIframe},
  )

  return (<animated.div style={springDisplay}>
  <div className={overlayIframes} style={desktopHeight}>
    <div className="hidden sm:block sm:bg-primary sm:w-1/3 sm:rounded-l-lg">
      <div className="mt-16 mx-4 mb-16">
        <img src="/assets/desktop_left_sidebar.png" className="object-contain w-full mx-auto" alt="NOCD can help by learning about what you are facing and offering information on if NOCD therapy is right for you." />
      </div>
    </div>
    <div className="sm:w-2/3 sm:rounded-r-lg" style={desktopHeight}>
      <div className={rightColumnClassNames}>
        <div className="mt-4 mb-2 mx-4">
          <ExitBackButtonHeader needsBack={true} />
        </div>

        <div className="flex-grow container max-w-sm mx-auto">
          <div className="text-center text-xs mb-3">
            Connect now? Call or text <span className="font-bold text-primary"><a href="tel:+13127666780">312-766-6780</a></span>
          </div>
          <div className="mb-6 mx-20 progress_bar">
            <SVGProgressBar4 />
          </div>
          <div>
            <h1 className="text-center font-bold us:text-base text-2xl">Enter your information</h1>
            <div className="mx-auto mb-4 text-center mt-2"> 
              <p className="inline-block us:text-sm ml-2 text-lg">{rendered}</p>
            </div>
          </div>
          <div className="mx-4 m_350:mt-4">
            <div className="inline-block relative w-full ">

              <input value={userData.firstName} onChange={(event) => handleChange(event)} onFocus={(event) => onFocus(event)}
                    placeholder="First name*" name="firstName" autoCorrect="off" autoComplete="on" required type="text"
                    style={{borderRight: (userValidation.firstName || userData.firstName === "") ? "" : "10px solid red"}}
                    className="placeholder-black block appearance-none w-full bg-white font-bold text-base border-4 sm:border-2 border-gray-400 all:px-3 all:py-2 m_350:px-5 m_350:pl-6 m_350:py-4 m_350:pr-6 sm:py-3 rounded-lg focus:outline-none focus:shadow-outline"></input>
              
              <input value={userData.lastName} onChange={(event) => handleChange(event)} onFocus={(event) => onFocus(event)}
                    placeholder="Last name*" name="lastName" autoCorrect="off" autoComplete="on" required type="text"
                    style={{borderRight: (userValidation.lastName || userData.lastName === "") ? "" : "10px solid red"}}
                    className="mt-3 placeholder-black block appearance-none w-full bg-white font-bold text-base border-4 sm:border-2 border-gray-400 all:px-3 all:py-2 m_350:px-5 m_350:pl-6 m_350:py-4 m_350:pr-6 sm:py-3 rounded-lg focus:outline-none focus:shadow-outline"></input>
                
              <input value={userData.email} onChange={(event) => handleChange(event)} onFocus={(event) => onFocus(event)}
                    placeholder="Email*" name="email" autoCorrect="off" autoComplete="email" autocapitalize="none" required type="text"
                    style={{borderRight: (userValidation.email || userData.email === "") ? "" : "10px solid red"}}
                    className="mt-3 placeholder-black block appearance-none w-full bg-white font-bold text-base border-4 sm:border-2 border-gray-400 all:px-3 all:py-2 m_350:px-5 m_350:pl-6 m_350:py-4 m_350:pr-6 sm:py-3 rounded-lg focus:outline-none focus:shadow-outline"></input>
              
              <input value={userData.phone} onChange={(event) => handleChange(event)} onFocus={(event) => onFocus(event)}
                    placeholder="Phone*" name="phone" autoCorrect="off" autoComplete="on" required type="text"
                    style={{borderRight: (userValidation.phone || userData.phone === "") ? "" : "10px solid red"}}
                    className="mt-3 placeholder-black block appearance-none w-full bg-white font-bold text-base border-4 sm:border-2 border-gray-400 all:px-3 all:py-2 m_350:px-5 m_350:pl-6 m_350:py-4 m_350:pr-6 sm:py-3 rounded-lg focus:outline-none focus:shadow-outline"></input>
            
            </div>                      
            <div className="text-center us:text-xs text-sm my-2 font-bold">I acknowledge that I am 18 years or older.</div>
          </div>
        </div>
        
        <div className="container max-w-sm mx-auto">
          <div className="text-center px-8 us:mb-4 mb-8 sm:mt-4">
              <button onClick={clickedNext} disabled={!formValid || isLoading} className= {((!formValid || isLoading) ? "bg-gray-400" : "bg-primary hover:bg-primary-hover") + " text-white font-bold py-4 w-full rounded-lg"}>
              {!isLoading ? <div>Book my appointment</div> : <ClipLoader className="m" size={25} color={"white"} loading={true} />}
              </button>
          </div>
        </div>

      </div>
    </div>
  </div>
  </animated.div>)
}

function AppointmentConfirmed(props) {
  const rendered = moment(props.time).tz(props.tz1 + "/" + props.tz2).format("dddd MMMM Do [at] h:mma z")
  const springDisplay = useSpring({opacity: 1, from: {opacity: 0}})
  const {schedulerState} = useContext(SchedulerContext);

  const [dimensions, setDimensions] = React.useState({ 
    height: window.innerHeight,
    width: window.innerWidth
  })

  React.useEffect(() => {
    const debouncedHandleResize = debounce(function handleResize() {
      console.log('resized to: ', window.innerWidth, 'x', window.innerHeight)
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth
      })
    });

    window.addEventListener('resize', debouncedHandleResize);
    return _ => { window.removeEventListener('resize', debouncedHandleResize) };
  });

  const isMobile = dimensions.width < 640;

  const desktopHeight = {}
  if (schedulerState.modalIframe && !isMobile) {
    desktopHeight["height"] = 682;
  } else if (!isMobile) {
    desktopHeight["height"] = 600;
  }

  const overlayIframes = classNames(
    "flex flex-col antialiased sm:container sm:max-w-3xl",
    {"sm:mt-10 sm:shadow-lg sm:rounded-lg sm:mx-auto": !schedulerState.modalIframe},
    {"body-flex": isMobile}
  )

  return (<animated.div style={springDisplay}>
    <div className={overlayIframes} style={desktopHeight}>
      <div className="container max-w-sm mx-auto">
          <ExitBackButtonHeader needsBack={false} />
          <div className="mb-8 mx-10 mt-16 mt-20 sm:mt-12 mx-auto w-1/4">
            <img src="/assets/positive_vote.png" className="object-contain w-full" alt="" />
          </div>
          <div>
              <h1 className="text-center font-bold text-lg">Appointment confirmed!</h1>
              <h2 className="text-center font-bold text-base mt-2">We look forward to speaking with you.</h2>
          </div>
          <div className="mx-10 mt-6 border-primary border-4 py-4 px-5 text-center">
              <p className="text-base">You will recieve an email confirming your 15 min call with the NOCD Care Team on:</p>
              <p className="font-bold mt-4 text-xl">{rendered}</p>
          </div>
      </div>
      <DoneButton />
    </div>
    </animated.div>
  )
}

function EnterWaitlistStateInformation(props) {
  const [isLoading, setIsLoading] = useState(false)
  const {schedulerState} = useContext(SchedulerContext);

  const [userData, setUserData] = useState({
    name: '',
    email: '',
    phone: ''
  })
  const [userValidation, setUserValidation] = useState({
      name: false,
      email: false,
      phone: false,
  })
  const [formValid, setFormValidation] = useState(false)
  const springDisplay = useSpring({opacity: 1, from: {opacity: 0}})

  const validateField = (fieldName, value) => {
    let { name, email, phone } = userValidation;
    switch (fieldName) {
        case 'email':
            var pattern = new RegExp(`(^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+[a-zA-Z0-9-.]+$)`);
            email = pattern.test(value);

            setUserValidation({
                ...userValidation, email
            })
            break;
        case 'name':
            pattern = new RegExp(`^[a-zA-Z ]+([a-zA-Z ]+)?$`);
            name = pattern.test(value);

            setUserValidation({
                ...userValidation, name
            })
            break;
        case 'phone':
            // var pattern = new RegExp('/^[(]?(\d{3})[)]?[-|\s]?(\d{3})[-|\s]?(\d{4})$/')
            phone = validator.isMobilePhone(value)
            setUserValidation({
                ...userValidation, phone
            })
            break;
        default:
            break;
    }
  }
  
  function handleChange(event) {
    const newData = { ...userData, [event.target.name]: event.target.value };
    setUserData(newData);
    validateField(event.target.name, event.target.value);
    validateForm()
  }

  function onFocus(event) {
    validateField(event.target.name, event.target.value)
    validateForm()
  }

  const validateForm = () => {
    let valid = userValidation.name && userValidation.email && userValidation.phone
    setFormValidation(valid)
  }


  const clickedNext = () => {
    validateForm()

    if (isLoading) {
      return;
    }

    if (formValid) {
      setIsLoading(true)

      axios.post(`${config.endpoint}/v1/api/premium_waitlist`, {
        name: userData.name,
        phone: userData.phone,
        email: userData.email,
        src: schedulerState.src,
        guid: schedulerState.guid,
        state: schedulerState.selectedState,
        insurance: 'NotProvided'
      })
      .then(function (response) {
        console.log("Response: ");
        console.log(response)
        navigate("/calendar/waitlist/confirmed");
      })
      .catch(function (error) {
        console.log("Error: ");
        console.log(error.response);

        var message = "An unexpected error occurred. Please contact info@nocdhelp.com";
        Swal.fire({
          title: 'Oops...',
          text: message,
          icon: 'error',
          confirmButtonColor: '#1f4b75'
        });  

      })
      .finally(function() {
        setIsLoading(false);
      })
          
    } else {
      Swal.fire({
        title: 'Oops...',
        text: 'Please enter the above fields to continue.',
        icon: 'error',
        confirmButtonColor: '#1f4b75'
      });  
    }
  }

  const isMobile = window.innerWidth < 640;
  const desktopHeight = {}
  if (schedulerState.modalIframe && !isMobile) {
    desktopHeight["height"] = 682;
  } else if (!isMobile) {
    desktopHeight["height"] = 682;
  }

  const payloadClassNames = classNames(
    "flex-col antialiased",
    {"body-flex": isMobile},
    "all:flex"
  )  

  const planeClasses = classNames(
    "object-contain w-full",
    {"rounded-t-lg": schedulerState.modalIframe}
  )

  const overlayIframes = classNames(
    "sm:flex-row sm:flex sm:w-full sm:max-w-3xl",
    {"sm:mt-10 sm:shadow-lg sm:rounded-lg sm:mx-auto": !schedulerState.modalIframe},
  )

  return (<animated.div style={springDisplay}>
    <div className={overlayIframes} style={desktopHeight}>
      <div className="sm:w-full sm:rounded-r-lg">
        <div className={payloadClassNames}>
          <div className="flex-grow container mx-auto max-w-3xl">
            <div className="all:mb-2 m_400:mb-4sm:mb-0 sm:relative">
                <div className="absolute right-4 top-4 z-50">
                  <ExitButton />
                </div>
                <img src="/assets/plane.svg" className={planeClasses} alt="Coming Soon" />
            </div>

            <div className="text-center sm:mx-12 mx-auto">
              <h1 className="font-bold all:text-lg m_400:text-xl sm:text-lg mb-2 leading-tight mx-4 sm:mx-16">NOCD Therapy isn't available there yet. But we're working hard to change that.</h1>
              <h2 className="mx-8 mt-2 sm:mt-4 text-sm">Because of regulations, we have to make sure we find the best therapists in each state first. But getting NOCD Therapy to you is our biggest priority: tell us how to reach out when it's ready!</h2>
            </div>


            <div className="mt-8 sm:mt-4 mx-8">
              <div className="mx-auto mx-24 sm:w-3/4">
                <div>
                  <input value={userData.name} onChange={(event) => handleChange(event)} onFocus={(event) => onFocus(event)}
                    placeholder="Name*" name="name" autoCorrect="off" autoComplete="off" required type="text"
                    style={{borderRight: (userValidation.name || userData.name === "") ? "" : "10px solid red"}}
                    className="mt-3 placeholder-black block appearance-none w-full sm:w-4/5 mx-auto bg-white font-bold all:text-base all:border-2 m_400:text-lg m_400:border-4 px-4 all:py-2 m_400:py-4 border-gray-400 sm:py-3 rounded-lg focus:outline-none focus:shadow-outline"></input>
                
                  <input value={userData.email} onChange={(event) => handleChange(event)} onFocus={(event) => onFocus(event)}
                    placeholder="Email*" name="email" autoCorrect="off" autoComplete="off" autocapitalize="none" required type="text"
                    style={{borderRight: (userValidation.email || userData.email === "") ? "" : "10px solid red"}}
                    className="mt-3 placeholder-black block appearance-none w-full sm:w-4/5 mx-auto bg-white font-bold all:text-base all:border-2 m_400:text-lg m_400:border-4 px-4 all:py-2 m_400:py-4 border-gray-400 sm:py-3 rounded-lg focus:outline-none focus:shadow-outline"></input>
              
                  <input value={userData.phone} onChange={(event) => handleChange(event)} onFocus={(event) => onFocus(event)}
                    placeholder="Phone*" name="phone" autoCorrect="off" autoComplete="off" required maxLength="25" type="text"
                    style={{borderRight: (userValidation.phone || userData.phone === "") ? "" : "10px solid red"}}
                    className="mt-3 placeholder-black block appearance-none w-full sm:w-4/5 mx-auto bg-white font-bold all:text-base all:border-2 m_400:text-lg m_400:border-4 px-4 all:py-2 m_400:py-4 border-gray-400 sm:py-3 rounded-lg focus:outline-none focus:shadow-outline"></input>
                </div>
              </div>
            </div>

          </div>
          <div className="container max-w-sm mx-auto all:mt-4 m_400:mt-8 sm:mt-5">
            <div className="text-center px-8 mb-8">
              <button className="bg-primary hover:bg-primary-hover text-white font-bold py-4 w-full rounded-lg" onClick={clickedNext}>
              Join the waitlist
              </button>
            </div>
          </div>
        </div>    
      </div>
    </div>
  </animated.div>);
}

function OutOfCountryInformation() {
  const springDisplay = useSpring({opacity: 1, from: {opacity: 0}})
  const {schedulerState} = useContext(SchedulerContext);

  const [dimensions, setDimensions] = React.useState({ 
    height: window.innerHeight,
    width: window.innerWidth
  })

  React.useEffect(() => {
    const debouncedHandleResize = debounce(function handleResize() {
      console.log('resized to: ', window.innerWidth, 'x', window.innerHeight)
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth
      })
    });

    window.addEventListener('resize', debouncedHandleResize);
    return _ => { window.removeEventListener('resize', debouncedHandleResize) };
  });

  const isMobile = dimensions.width < 640;

  const desktopHeight = {}
  if (schedulerState.modalIframe && !isMobile) {
    desktopHeight["height"] = 682;
  } else if (!isMobile) {
    desktopHeight["height"] = 600;
  }

  const payloadClassNames = classNames(
    "flex-col antialiased",
    {"body-flex": isMobile},
    "all:flex"
  )  

  const planeClasses = classNames(
    "object-contain w-full",
    {"rounded-t-lg": schedulerState.modalIframe}
  )

  const overlayIframes = classNames(
    "sm:flex-row sm:flex sm:w-full sm:max-w-3xl",
    {"sm:mt-10 sm:shadow-lg sm:rounded-lg sm:mx-auto": !schedulerState.modalIframe},
  )


  return (<animated.div style={springDisplay}>
    <div className={overlayIframes} style={desktopHeight}>
      <div className="sm:w-full sm:rounded-r-lg">
        <div className={payloadClassNames}>
          <div className="flex-grow container mx-auto max-w-3xl">
            <div className="all:mb-2 m_400:mb-4 sm:relative">
                <div className="absolute right-4 top-4 z-50">
                  <ExitButton />
                </div>
                <img src="/assets/plane.svg" className={planeClasses} alt="Coming Soon" />
            </div>

            <div className="text-center all:mx-5 sm:mx-12 mx-auto sm:mb-8">
              <h1 className="font-bold all:text-lg m_400:text-xl sm:text-2xl mb-2 leading-tight mx-4">We’re sorry that NOCD Therapy isn't available outside the U.S. now. However, your treatment journey doesn't have to wait!</h1>
              <h2 className="mx-8 mt-2 sm:mt-4 text-base sm:text-lg">The NOCD app is a great place to get started with treatment tools, a supportive community, and more.</h2>
            </div>


            <div className="flex justify-center items-center all:mt-8 sm:mt-8">
              <a target="_blank" rel="noopener noreferrer" className="flex justify-center bg-primary w-1/3 px-4 py-4 mx-4 rounded-full" href='https://itunes.apple.com/us/app/nocd-ocd-treatment-app/id1063365447?utm_source=newwebsite'>
                <img src="/assets/app_store.png" alt="Apple App Store Icon" className="object-contain w-full"/>
              </a>
              <a target="_blank" rel="noopener noreferrer" className="flex justify-center bg-primary w-1/3 px-4 py-4 mx-4 rounded-full" href='https://play.google.com/store/apps/details?id=com.treatmyocd.nocd&referrer=utm_source%3DNewWebsite'>
                <img src="/assets/play_store.png" alt="Google Play Store Icon" className="object-contain w-full"/>
              </a>
            </div>

          </div>
          <div className="container mx-auto mx-8 all:w-2/3 m_400:w-3/4 sm:hidden">
            <img src="/assets/nocd-banner-app.png" className="object-contain w-full" alt="" />
          </div>    
        </div>    
      </div>
    </div>
  </animated.div>)
}

function WaitlistThankYou() {
  const springDisplay = useSpring({opacity: 1, from: {opacity: 0}})
  const {schedulerState} = useContext(SchedulerContext);

  const [dimensions, setDimensions] = React.useState({ 
    height: window.innerHeight,
    width: window.innerWidth
  })

  React.useEffect(() => {
    const debouncedHandleResize = debounce(function handleResize() {
      console.log('resized to: ', window.innerWidth, 'x', window.innerHeight)
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth
      })
    });

    window.addEventListener('resize', debouncedHandleResize);
    return _ => { window.removeEventListener('resize', debouncedHandleResize) };
  });

  const isMobile = dimensions.width < 640;

  const desktopHeight = {}
  if (schedulerState.modalIframe && !isMobile) {
    desktopHeight["height"] = 682;
  } else if (!isMobile) {
    desktopHeight["height"] = 600;
  }

  const overlayIframes = classNames(
    "flex flex-col antialiased sm:container sm:max-w-3xl",
    {"sm:mt-10 sm:shadow-lg sm:rounded-lg sm:mx-auto": !schedulerState.modalIframe},
    {"body-flex": isMobile}
  )

  return <animated.div style={springDisplay}>
  <div className={overlayIframes} style={desktopHeight}>
    <div className="flex-grow container max-w-sm mx-auto">
        <ExitButton />
        <div className="mx-10 pt-32">
            <img src="/assets/waitlist_thank_you.svg" alt="Thank you for joining the waitlist" 
                 className="object-contain w-full mx-auto"/>
        </div>
    </div>
    <DoneButton />
  </div>
  </animated.div>
}

export default App;
